module.exports = __webpack_public_path__ + "img/banner-ifdo.ae9620d8.png";